// extracted by mini-css-extract-plugin
module.exports = {"tagCloud":"sphere_tagCloud__2oU2i","tagCloud__item":"sphere_tagCloud__item__6zit7"};